import { render, staticRenderFns } from "./ABtestDetail.vue?vue&type=template&id=b7a807a4&scoped=true"
import script from "./ABtestDetail.vue?vue&type=script&lang=js"
export * from "./ABtestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a807a4",
  null
  
)

export default component.exports